import { useEffect, useState, type CSSProperties } from "react";

type AvatarImgWithVariantFallbackProps = {
  primary: string | null;
  fallback: string | null;
  imgClassName: string;
  style?: CSSProperties;
  letterClassName: string;
  initial: string;
};

/**
 * Tries `primary`, then `fallback` on image error, then shows the letter placeholder.
 */
export function AvatarImgWithVariantFallback({
  primary,
  fallback,
  imgClassName,
  style,
  letterClassName,
  initial,
}: AvatarImgWithVariantFallbackProps) {
  const [stage, setStage] = useState(0);
  useEffect(() => {
    setStage(0);
  }, [primary, fallback]);

  if (!primary && !fallback) {
    return <span className={letterClassName}>{initial}</span>;
  }

  const src = stage === 0 ? primary : stage === 1 ? fallback : null;

  if (stage >= 2 || !src) {
    return <span className={letterClassName}>{initial}</span>;
  }

  return (
    <img
      key={src}
      src={src}
      className={imgClassName}
      style={style}
      alt=""
      onError={() => {
        setStage((s) => {
          if (s === 0 && fallback) return 1;
          return 2;
        });
      }}
    />
  );
}
